import { CONFIG } from "./config";

// Robust parse of the event target time in ms.
// Guarantees a stable numeric target even if eventDate is malformed.
export function getEventTargetMs() {
  const raw = CONFIG.eventDate;
  const ms = Date.parse(raw);
  if (Number.isFinite(ms)) return ms;
  // Fallback: assume Paris timezone if no offset supplied
  const fallback = Date.parse(raw + "+02:00");
  if (Number.isFinite(fallback)) return fallback;
  return Date.now();
}

// Human-readable label of the event target in Paris time, e.g.
// "vendredi 19 septembre 2026 · 22h00 (Paris)"
export function formatEventLabel() {
  try {
    const d = new Date(getEventTargetMs());
    const date = new Intl.DateTimeFormat("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: CONFIG.eventTimezone,
    }).format(d);
    const time = new Intl.DateTimeFormat("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: CONFIG.eventTimezone,
    })
      .format(d)
      .replace(":", "h");
    return `${date} · ${time} (Paris)`;
  } catch {
    return "";
  }
}

// Split ms remaining into parts.
export function splitDuration(ms) {
  const clamped = Math.max(0, ms);
  return {
    days: Math.floor(clamped / (1000 * 60 * 60 * 24)),
    hours: Math.floor((clamped / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((clamped / (1000 * 60)) % 60),
    seconds: Math.floor((clamped / 1000) % 60),
    totalMs: clamped,
  };
}
